
		<ng-template #OBJ_template_ref>
			<div class="modal-body text-center gray-bg">
				<p>{{OBJ_field_config.config?.buttonText|translate}}?</p>
				<button class="btn btn-primary btn-circle" (click)="execute()" title="{{'confirm'|translate}}"><i class="fa fa-check"></i></button>
				<button class="btn btn-warning btn-circle" (click)="hideModal()" title="{{'abort'|translate}}"><i class="fa fa-remove"></i></button>
			</div>
		</ng-template>
		<div
			class="form-group tig-form-button"
			[formGroup]="OBJ_form_group"
			[ngClass]="{'has-error': isInvalid()}">
			<label class="col-lg-2 control-label" [ngClass]="{'tgi-required': isRequired()}"><span *ngIf="getLabelName().length">{{getLabelName()|translate}}</span>
				<span *ngIf="isRequired()" class="tgi-asterisk"> *</span></label>
			<div *ngIf="button_show" class="col-lg-8">
				<button *ngIf="!OBJ_field_config?.config?.translation" class="tig-button b-r-xs" [ngClass]="OBJ_field_config?.config?.class" (click)="onClick(OBJ_template_ref)">{{OBJ_field_config.config.buttonText|translate}}</button>
				<div *ngIf="OBJ_field_config?.config?.translation" class="tig-button b-r-xs" [ngClass]="OBJ_field_config?.config?.class" (click)="is_open=!is_open" tigClickedOutside (onClickedOutside)="clickedOutside($event)">
					<div>{{OBJ_field_config.config?.buttonText|translate}}</div>
					<div class="tig-dropdown" [ngStyle]="{display:is_open?'block':'none'}">
						<ng-container *ngFor="let STR_lang of translateService.getLangs()">
							<button class="btn btn-primary btn-circle" type="button" (click)="language=STR_lang;onClick(OBJ_template_ref)">{{STR_lang.toUpperCase()}}</button>
						</ng-container>
					</div>
				</div>
				<div class="tig-hint">{{OBJ_field_config?.config?.hint|translate}}</div>
				<tig-form-error [OBJ_form_control]="OBJ_form_group.get(OBJ_field_config.name)"></tig-form-error>
			</div>
			<div *ngIf="preview_links.length > 0" class="col-lg-8">
				<div *ngFor="let preview_link of preview_links;">
					<a href="{{preview_link}}" target="_blank">{{preview_link}}</a>
					<a class="m-l-sm" (click)="helperService.copyStringToClipboard(preview_link, 'oSuccess.sCopiedToClipboard')">
						<i class="fa fa-copy" title="{{translateService.instant('oMisc.sCopyToClipboard')}}"></i>
					</a>
				</div>
			</div>
		</div>
	